import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'util/objects'
import { doToggleLabel } from 'actions/labelings/shared/index'
import { selectLabelsWithAppliedUpdates } from 'selectors/labelings'
import { convertGidToRaw } from 'util/scatterSwap'
import Label from '@groovehq/internal-design-system/lib/assets/icons/Label'

import ActionIcon from '../ActionIcon'
import Tag from './Tag'
import { styles } from './styles'

export default function SuggestedTags({ ticketId, suggestion }) {
  const dispatch = useDispatch()
  const ticketLabels = useSelector(selectLabelsWithAppliedUpdates)

  const onClick = useCallback(
    tag => {
      dispatch(
        doToggleLabel(ticketId, { id: convertGidToRaw(tag.id), name: tag.name })
      )
    },
    [dispatch, ticketId]
  )

  const tags = useMemo(
    () => {
      if (!suggestion.tags) {
        return []
      }

      return suggestion.tags.filter(
        tag =>
          !ticketLabels.some(
            ticketLabel => ticketLabel.id === convertGidToRaw(tag.id).toString()
          )
      )
    },
    [suggestion, ticketLabels]
  )

  if (isEmpty(suggestion)) {
    return null
  }

  return (
    <div className="grui flex mt-6">
      <ActionIcon>
        <Label />
      </ActionIcon>

      <span className="grui mt-5 mr-3 whitespace-nowrap" css={styles.title}>
        Auto tag
      </span>

      {tags.length ? (
        <div
          className="grui flex flex-row items-start mt-3 ml-auto"
          css={styles.tagsList}
        >
          {tags.map(tag => <Tag key={tag.id} tag={tag} onClick={onClick} />)}
        </div>
      ) : (
        <span className="grui mt-5 mr-3" css={styles.emptyText}>
          No tags
        </span>
      )}
    </div>
  )
}
